/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Orders_ConfirmedInputs */

const vi_report_orders_confirmed = /** @type {(inputs: Report_Orders_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xác nhận`)
};

/**

* @param {Report_Orders_ConfirmedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_orders_confirmed = /** @type {((inputs?: Report_Orders_ConfirmedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Orders_ConfirmedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_orders_confirmed(inputs)
});